import Image from 'next/image';
import { cn } from '../../../lib/utils';

const DEFAULT_STEP_ILLUSTRATION = '/img/option-two.webp';

export type MatchQuizStepIllustrationProps = {
  /** Root-relative (`/…`) or absolute URL; defaults to the bundled dog–cat illustration. */
  src?: string | null;
  alt?: string;
  className?: string;
};

/**
 * Desktop hero slot beside match questions. Uses `/img/option-two.webp` by default; pass `src` to override.
 */
export function MatchQuizStepIllustration({
  src,
  alt = 'A dog and a cat sitting together on a sofa',
  className,
}: MatchQuizStepIllustrationProps) {
  const imageSrc = src?.trim() || DEFAULT_STEP_ILLUSTRATION;

  return (
    <div
      className={cn(
        'relative aspect-[4/5] min-h-[12rem] overflow-hidden rounded-3xl border border-border bg-muted shadow-sm lg:aspect-auto lg:min-h-[22rem]',
        className,
      )}
    >
      <Image
        src={imageSrc}
        alt={alt}
        fill
        className='object-cover object-center'
        sizes='(max-width: 1024px) 100vw, min(640px, 45vw)'
      />
    </div>
  );
}
